import styled from 'styled-components';
import NotificationToastIconSVG from '../../assets/images/notification-toast-icon.svg';

const NotificationToastIcon = styled.span`
  background: url(\"${NotificationToastIconSVG}\") no-repeat center center;
  background-size: 24px 25px;
  display: inline-block;
  height: 35px;
  width: 35px;
  position: relative;
  cursor: pointer;
`;

export default NotificationToastIcon;
